import { Button } from '@/components/ui/button'
import { PUBLIC_LANDING_ROUTES } from '@/setup/routing/routing'
import { SuperscaleMark } from '@/features/landing-page/v3/superscale-mark'
import { LpSectionHeading } from '@/features/landing-page/v3/lp-section-heading'
import { LpCaseStudiesCarousel } from '@/features/landing-page/v3/sections/lp-case-studies-carousel'
import { LP_GRID } from '@/features/landing-page/v3/lp-grid'

/**
 * lp-v3 case-study section — "Customer results from world class marketing teams". Centered header
 * (clover mark + two-line heading + CTA) over a horizontal card carousel. SERVER component: the
 * header and every card ship in the static HTML; only the carousel's mobile dots run JS.
 * `!` overrides the `.ds2` heading/paragraph defaults.
 */
export function LpCaseStudiesSection() {
    return (
        <section className="bg-background py-[60px] md:py-[100px]">
            <div className={`${LP_GRID.content} ${LP_GRID.contentSection} flex flex-col items-center gap-5 text-center`}>
                <SuperscaleMark className="size-9 text-foreground md:size-10" />

                <LpSectionHeading line1="Customer results from" line2="world class marketing teams" />

                <Button href={PUBLIC_LANDING_ROUTES.CASE_STUDY} variant="lp-primary" size="lp-lg" className="mt-1">
                    All customer stories
                </Button>
            </div>

            <div className="mt-10 md:mt-14">
                <LpCaseStudiesCarousel />
            </div>
        </section>
    )
}
